import React from 'react';
import MultiRowInput, { MultiRowInputProps } from '../MultiRowInput';
import DataFilterRow, { DataFilterRowPropTypes } from './DataFilterRow';
import { FilterColumns } from './types/filterTypes';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type DataFilterMenuGroupProps = DataFilterRowPropTypes<any> &
  Omit<MultiRowInputProps, 'children' | 'onChange' | 'onRemove' | 'columns' | 'data'> & {
    onRemove?: (() => void) | undefined;
    columns: FilterColumns[];
  };

export const DataFilterMenuGroup = ({
  index,
  filter,
  columns,
  filterId,
  onColumnChange,
  onFilterChange,
  onAdd = () => undefined,
  onRemove = () => undefined,
  disabled = false,
  ...props
}: DataFilterMenuGroupProps) => {
  return (
    <MultiRowInput onAdd={onAdd} onRemove={onRemove} index={index} confirmModal={false} disableAdd={disabled}>
      <DataFilterRow
        filter={filter}
        columns={columns}
        key={`filter-${filterId}`}
        filterId={filterId}
        onColumnChange={onColumnChange}
        onFilterChange={onFilterChange}
        {...props}
      />
    </MultiRowInput>
  );
};
